
import { getLastRegularSeason, getSeasonById } from "helpers/ladder";
import React, { PureComponent } from "react";
import dwhExport from '~/dwhExport'
import { connect } from "react-redux";
import { State } from "../../types/State";
import {
  changeClanTeamNumber,
  changeClanBattleType,
  closeClanDescriptionDialog,
  closeClanDescriptionEditDialog,
  closeClanNameEditDialog,
  closeClanRulesDialog,
  closeLeaveDialog,
  fetchClan,
  fetchMembers,
  openClanDescriptionDialog,
  openClanDescriptionEditDialog,
  openClanNameEditDialog,
  openClanRulesDialog,
  openLeaveDialog,
  setClanProfileCurrentSeason,
  toggleAllMembersTick,
  toggleMembersSorting,
  openOldRecommendationsDialog,
  closeOldRecommendationsDialog,
  openRecommendationsDialog,
  closeRecommendationsDialog,
  toggleMemberTick
} from "../Actions/ActionClanProfile";
import { hideDialog } from "../Actions/ActionDialog";
import ViewClanProfile from "../Components/ViewClanProfile/ViewClanProfile";
import {
  showAcceptInviteDialog,
  showSendApplicationDialog
} from "../helpers/dialog";
import { getClanBaseByClanId } from "../helpers/supply";
import {
  clanSelector,
  clanStatisticsSelector,
  defaultSort,
  statisticsSelector
} from "./selectors/SelectorClanProfile";
import get from 'lodash/get'

export type ContainerClanProfile_Props = any;

class ContainerClanProfile extends PureComponent<ContainerClanProfile_Props, any> {


  componentDidMount() {
    this.props.onRender(this.props.clanId);
  }

  componentWillUnmount() {
    this.props.closeClanDescriptionDialog();
    this.props.closeClanDescriptionEditDialog();
    this.props.closeClanNameEditDialog();
    this.props.closeClanRulesDialog();
    this.props.closeOldRecommendationsDialog()
    this.props.closeRecommendationsDialog()
    this.props.closeLeaveDialog();
  }

  render() {
    return (
      <ViewClanProfile
        clanId={this.props.clanId}
        currentAccount={this.props.currentAccount}
        currentSeasonType={this.props.currentSeasonType}
        currentSeason={this.props.currentSeason}
        clan={this.props.clan}
        statistics={this.props.statistics}
        selectedBattleType={this.props.selectedBattleType}
        selectedTeamNumber={this.props.selectedTeamNumber}
        hasBase={this.props.hasBase}
        membersError={this.props.membersError}
        isHiddenStatistics={this.props.isHiddenStatistics}
        isMissingStatistics={this.props.isMissingStatistics}
        isFetchingJoinClan={this.props.isFetchingJoinClan}
        isOwn={this.props.isOwn}
        routeQuery={this.props.routeQuery}
        isSidebarOpened={this.props.isSidebarOpened}
        wowsLadder={this.props.wowsLadder}
        supplySelectedBuilding={this.props.supplySelectedBuilding}
        isMapZoomed={this.props.isMapZoomed}
        isClanDescriptionDialogVisible={this.props.isClanDescriptionDialogVisible}
        isClanDescriptionEditDialogVisible={this.props.isClanDescriptionEditDialogVisible}
        isClanNameEditDialogVisible={this.props.isClanNameEditDialogVisible}
        isClanRulesDialogVisible={this.props.isClanRulesDialogVisible}
        clanRulesContent={this.props.clanRulesContent}
        isOldRecommendationsDialogVisible={this.props.isOldRecommendationsDialogVisible}
        isRecommendationsDialogVisible={this.props.isRecommendationsDialogVisible}
        isLeaveDialogVisible={this.props.isLeaveDialogVisible}
        hideLeagueIcon={this.props.hideLeagueIcon}
        accumulativeResource={this.props.accumulativeResource}
        lastRegularSeasonData={this.props.lastRegularSeasonData}
        onNameEditClick={this.props.onNameEditClick}
        onSeasonChange={this.props.onSeasonChange}
        onBattleTypeChange={this.props.onBattleTypeChange}
        onTeamNumberChange={this.props.onTeamNumberChange}
        onMembersReloadClick={this.props.onMembersReloadClick}
        onClanReloadClick={this.props.onClanReloadClick}
        onClanDescriptionClick={this.props.onClanDescriptionClick}
        onAcceptInvite={this.props.onAcceptInvite}
        onSendApplication={this.props.onSendApplication}
        closeClanDescriptionDialog={this.props.closeClanDescriptionDialog}
        openClanDescriptionEditDialog={this.props.openClanDescriptionEditDialog}
        closeClanDescriptionEditDialog={this.props.closeClanDescriptionEditDialog}
        closeClanNameEditDialog={this.props.closeClanNameEditDialog}
        openClanRulesDialog={this.props.openClanRulesDialog}
        closeClanRulesDialog={this.props.closeClanRulesDialog}
        onRulesDialogClick={this.props.onRulesDialogClick}
        openOldRecommendationsDialog={this.props.openOldRecommendationsDialog}
        openRecommendationsDialog={this.props.openRecommendationsDialog}
        closeOldRecommendationsDialog={this.props.closeOldRecommendationsDialog}
        closeRecommendationsDialog={this.props.closeRecommendationsDialog}
        onOldRecommendationsClanSettingsClick={this.props.onOldRecommendationsClanSettingsClick}
        onRecommendationsClanSettingsClick={this.props.onRecommendationsClanSettingsClick}
        onLeaveClick={this.props.onLeaveClick}
        openLeaveDialog={this.props.openLeaveDialog}
        closeLeaveDialog={this.props.closeLeaveDialog}
      />
    )
  }
}

const mapStateToProps = (state: State, ownProps: ContainerClanProfile_Props) => {
  const extClanId = (ownProps.params && ownProps.params.clanId) ? parseInt(ownProps.params.clanId) : null;
  const clanId = extClanId ? extClanId : state.currentAccount.clanId;
  const isOwn = !extClanId && state.currentAccount.clanId;
  const clan = clanSelector(state, clanId);
  const currentClanStatistics = clanStatisticsSelector(state, clanId);
  const isMissingStatistics = currentClanStatistics ? currentClanStatistics.isMissingStatistics : false;
  const isHiddenStatistics = currentClanStatistics ? currentClanStatistics.isHiddenStatistics : false;
  const membersState = state.members.clans[clanId];
  const sort = membersState ? membersState.sort : defaultSort;
  const base = getClanBaseByClanId(state, clanId);
  const membersError = membersState ? membersState.error : '';

  let hideLeagueIcon = false;
  const lastRegularSeason = getLastRegularSeason();
  let lastRegularSeasonData = {};

  if (state.clans.wowsLadder[clanId]) {
    state.clans.wowsLadder[clanId].ratings.forEach(season => {
      const lastRegularSeasonId = lastRegularSeason ? lastRegularSeason.id : null;

      if (season.is_best_season_rating && season.season_number === lastRegularSeasonId) {
        lastRegularSeasonData = season;
        if (season.battles_count === 0 && season.public_rating <= state.clans.wowsLadder[clanId].initial_public_rating) {
          hideLeagueIcon = true;
        }
      }
    });
  }

  if (!lastRegularSeason) {
    hideLeagueIcon = true;
  }

  const currentSeason = getSeasonById(state.members.currentSeason) || {};
  const currentClanLadderInfo = state.clans.items[state.currentAccount.clanId]


  return {
    accumulativeResource: currentClanLadderInfo ? currentClanLadderInfo.accumulativeResource : 0,
    clanId: clanId,
    clan: state.clans.items[clanId],
    isOwn: isOwn,
    currentAccount: state.currentAccount,

    hideLeagueIcon: hideLeagueIcon,
    lastRegularSeasonData: lastRegularSeasonData,

    isFetchingJoinClan: state.applications.isFetchingJoinClan,
    isFetchingMembers: state.members.isFetching[clanId],
    isHiddenStatistics,
    isMissingStatistics,
    isRenameInProcess: state.clanRename.isProcessing,

    statistics: statisticsSelector(state, clanId),
    clanRulesContent: state.content.clansRulesPage,
    selectedBattleType: state.members.battleTypes[clanId],
    selectedTeamNumber: state.members.teamNumber[clanId],
    wowsLadder: state.clans.wowsLadder,
    currentSeasonType: currentSeason.kind,
    currentSeason: state.members.currentSeason,

    isOldRecommendationsDialogVisible: state.clanProfile.isOldRecommendationsDialogVisible,
    isClanDescriptionDialogVisible: state.clanProfile.isClanDescriptionDialogVisible,
    isClanDescriptionEditDialogVisible: state.clanProfile.isClanDescriptionEditDialogVisible,
    isClanNameEditDialogVisible: state.clanProfile.isClanNameEditDialogVisible,
    isClanRulesDialogVisible: state.clanProfile.isClanRulesDialogVisible,
    isRecommendationsDialogVisible: state.clanProfile.isRecommendationsDialogVisible,
    isLeaveDialogVisible: state.clanProfile.isLeaveDialogVisible,

    supplySelectedBuilding: state.ReducerSupply.selectedBuildingId,
    isMapZoomed: state.ReducerSupply.zoom > 6,
    isSidebarOpened: state.ReducerSupply.isSidebarOpened,
    base: base
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {

  const extClanId = (ownProps.params && ownProps.params.clanId) ? parseInt(ownProps.params.clanId) : null;

  return {
    onSeasonChange: (season, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(setClanProfileCurrentSeason(season));
      dispatch(fetchMembers(currentClanId));
    },
    onTeamNumberChange: (selectedTeamNumber, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(changeClanTeamNumber(currentClanId, selectedTeamNumber));
      dispatch(fetchMembers(currentClanId));
    },
    onSendApplication: clan => {
      const sourceQuery = get(ownProps, 'location.query.source', null)

      const source = sourceQuery || (ownProps.source || 'profile');

      dispatch(showSendApplicationDialog(clan, source));
    },
    onAcceptInvite: invite => {
      dispatch(hideDialog());
      dispatch(showAcceptInviteDialog(invite));
    },
    openLeaveDialog: () => {
      dispatch(openLeaveDialog());
    },
    closeLeaveDialog: () => {
      dispatch(closeLeaveDialog());
    },
    onOldRecommendationsClanSettingsClick: () => {
      dispatch(openOldRecommendationsDialog())
    },
    onRecommendationsClanSettingsClick: () => {
      dispatch(openRecommendationsDialog())
    },
    openOldRecommendationsDialog: () => {
      dispatch(openOldRecommendationsDialog())
    },
    closeOldRecommendationsDialog: () => {
      dispatch(closeOldRecommendationsDialog())
    },
    openRecommendationsDialog: () => {
      dispatch(openRecommendationsDialog())
    },
    closeRecommendationsDialog: () => {
      dispatch(closeRecommendationsDialog())
    },
    onLeaveClick: () => {
      dispatch(openLeaveDialog());
    },
    onRulesDialogClick: () => {
      dispatch(openClanRulesDialog());
    },
    onNameEditClick: () => {
      dispatch(openClanNameEditDialog());
    },
    openClanRulesDialog: () => {
      dispatch(openClanRulesDialog());
    },
    closeClanRulesDialog: () => {
      dispatch(closeClanRulesDialog());
    },
    openClanNameEditDialog: () => {
      dispatch(openClanNameEditDialog());
    },
    closeClanNameEditDialog: () => {
      dispatch(closeClanNameEditDialog());
    },
    openClanDescriptionEditDialog: () => {
      dispatch(openClanDescriptionEditDialog());
    },
    closeClanDescriptionEditDialog: () => {
      dispatch(closeClanDescriptionEditDialog());
    },
    onClanDescriptionClick: () => {
      if (!extClanId){
          dwhExport.send('supply.view_description')
      }
      dispatch(openClanDescriptionDialog());
    },
    closeClanDescriptionDialog: () => {
      dispatch(closeClanDescriptionDialog());
    },
    onThSortClick: (field, isAsc, hiddenSortingNames, clanId) => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(toggleMembersSorting(currentClanId, field, isAsc, hiddenSortingNames));
    },
    onBattleTypeChange: (selectedBattleType, clanId) => {
      const currentClanId = clanId ? clanId : extClanId;
      dispatch(changeClanBattleType(currentClanId, selectedBattleType));
      dispatch(fetchMembers(currentClanId));
    },
    onMembersReloadClick: clanId => {
      const currentClanId = clanId ? clanId : ownProps.clanId;
      dispatch(fetchMembers(currentClanId));
    },
    onRender: clanId => {
      dispatch(fetchClan(clanId));
      dispatch(fetchMembers(clanId, true));
    },
    onClanReloadClick: () => {
      dispatch(fetchClan(ownProps.clanId, false));
      dispatch(fetchMembers(ownProps.clanId));
    },
    onTickMember: member => {
      dispatch(toggleMemberTick(member));
    },
    onTickAllMembers: members => {
      dispatch(toggleAllMembersTick(members));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContainerClanProfile);